module.exports = __webpack_public_path__ + "static/media/Caixa7.756cf3a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelCaixa/Caixa7.png
// module id = 2036
// module chunks = 0